var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_2970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 11.8C16.6 11.1 17.2 10 17.2 9C17.2 7.93913 16.7786 6.92172 16.0284 6.17157C15.2783 5.42143 14.2609 5 13.2 5H7V19H14C16.1 19 17.7 17.3 17.7 15.2C17.7 13.7 16.9 12.4 15.6 11.8ZM10 7.5H13C13.3978 7.5 13.7794 7.65804 14.0607 7.93934C14.342 8.22064 14.5 8.60218 14.5 9C14.5 9.39782 14.342 9.77936 14.0607 10.0607C13.7794 10.342 13.3978 10.5 13 10.5H10V7.5ZM13.5 16.5H10V13.5H13.5C13.8978 13.5 14.2794 13.658 14.5607 13.9393C14.842 14.2206 15 14.6022 15 15C15 15.3978 14.842 15.7794 14.5607 16.0607C14.2794 16.342 13.8978 16.5 13.5 16.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_2947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/Bold.f6d605647bfe2bf747b368a46250e289.svg";
export { ForwardRef as ReactComponent };